
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "vue-property-decorator";
import { BgInputNumber } from "@banggood/scm-fe";
import { sourceTypeEnum } from "@/service/supplier-meta/enums/sourceTypeEnum";
import BgAreaSelect, {
  BgAreaSelectOption,
} from "@/components/bg-area-select/index.vue";
import { SupplierForm } from "@/service/supplier-meta/common/SupplierForm";
import {
  ElementUIFormRules,
  ElementUIFormItemRule,
} from "@/service/supplier-meta/common/supplier-field-ctrl";
import { Form } from "element-ui";
import { Any } from "@/service/common/entity/Any";
import { FormModel } from "@/service/common/entity/FormModel";
@Component({
  components: {
    BgInputNumber,
    BgAreaSelect,
  },
})
export default class SupplierCreate extends SupplierForm {
  form = {
    address: {
      shipAreas: [] as string[],
      shipAddress: "",
      receiverAreas: [] as string[],
      receiverAddress: "",
      receiverName: "",
      receiverPhone: "",
    },
  };
  get rules(): ElementUIFormRules {
    return {
      ...this.getFieldsRules(["address.receiverName", "address.receiverPhone"]),
      "address.shipAddress": (
        [
          {
            validator: (
              rules: ElementUIFormRules,
              value: Any,
              callback: (msg?: string) => void
            ) => {
              if (!this.form.address.shipAreas[0]) {
                callback("省份不能为空");
              } else if (!this.form.address.shipAreas[1]) {
                callback("城市不能为空");
              } else if (
                !this.form.address.shipAreas[2] &&
                sourceTypeEnum.oa === this.sourceType
              ) {
                callback("地区不能为空");
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ] as ElementUIFormItemRule[]
      ).concat(this.getFieldRules("address.shipAddress")),
      "address.receiverAddress": (
        [
          {
            validator: (
              rules: ElementUIFormRules,
              value: Any,
              callback: (msg?: string) => void
            ) => {
              if (!this.form.address.shipAreas[0]) {
                callback("省份不能为空");
              } else if (!this.form.address.shipAreas[1]) {
                callback("城市不能为空");
              } else if (
                !this.form.address.shipAreas[2] &&
                sourceTypeEnum.oa === this.sourceType
              ) {
                callback("地区不能为空");
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ] as ElementUIFormItemRule[]
      ).concat(this.getFieldRules("address.receiverAddress")),
    };
  }
  getFormRef() {
    return this.$refs.form as Form;
  }
  getFormData() {
    return {
      ...this.form,
      address: {
        shipProvince: this.form.address.shipAreas[0] || null,
        shipCity: this.form.address.shipAreas[1] || null,
        shipArea: this.form.address.shipAreas[2] || null,
        shipAddress: this.form.address.shipAddress,
        receiverProvince: this.form.address.receiverAreas[0] || null,
        receiveCity: this.form.address.receiverAreas[1] || null,
        receiveArea: this.form.address.receiverAreas[2] || null,
        receiverAddress: this.form.address.receiverAddress,
        receiverName: this.form.address.receiverName,
        receiverPhone: this.form.address.receiverPhone,
      },
    };
  }
  isAreaSelectOptionDisabled(opt: BgAreaSelectOption, level: number): boolean {
    return level === 1 || level == 2;
  }
  handleShipAreasChange(val: string[]): void {
    if (Array.isArray(val) && val.length && this.form.address.shipAddress) {
      const form = this.$refs.form as Form;
      form.validateField("address.shipAddress");
    }
  }
  handleReceiverAreasChange(val: string[]): void {
    if (Array.isArray(val) && val.length && this.form.address.receiverAddress) {
      const form = this.$refs.form as Form;
      form.validateField("address.receiverAddress");
    }
  }
  patchFormData(formData: FormModel) {
    super.patchFormData(formData);
    const address = (formData.address as any) || {};
    const shipAreas = [];
    const receiverAreas = [];
    if (address.shipProvince) {
      shipAreas[0] = address.shipProvince;
    }
    if (address.shipCity) {
      shipAreas[1] = address.shipCity;
    }
    if (address.shipArea) {
      shipAreas[2] = address.shipArea;
    }
    this.form.address.shipAreas = shipAreas;
    if (address.receiverProvince) {
      receiverAreas[0] = address.receiverProvince;
    }
    if (address.receiveCity) {
      receiverAreas[1] = address.receiveCity;
    }
    if (address.receiveArea) {
      receiverAreas[2] = address.receiveArea;
    }
    this.form.address.receiverAreas = receiverAreas;
  }
}
